module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/page8-icon2.428c2705.png";